
export default class ReferralLink{
    constructor(jsonResponse) {
        this.referralLink = jsonResponse["referral-link"];
    }
}
